module.exports = __webpack_public_path__ + "static/media/metamask-logo.fd681d4a.svg";